import {
  UPDATE_LEAD_CAPTURE,
  UPDATE_LEAD_CAPTURE_SUCCESS,
  UPDATE_LEAD_CAPTURE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateLeadCaptureReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LEAD_CAPTURE:
      return { ...state, loading: true };
    case UPDATE_LEAD_CAPTURE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_LEAD_CAPTURE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateLeadCaptureReducer;
